import {
  ChatBubbleLeftEllipsisIcon,
  CubeIcon,
  FireIcon,
  LightBulbIcon,
  NewspaperIcon,
  RocketLaunchIcon,
  TrophyIcon,
} from '@heroicons/react/24/solid';
import { GameIcon } from '@/components/GameIcon';
import { BonusesIcon } from '@/components/icons/menu/BonusesIcon';
import { BookmakersIcon } from '@/components/icons/menu/BookmakersIcon';
import { Game } from '@/constants/game.const';
import {
  type MenuItemGroup,
  type NavItem,
  NavItemType,
} from '@/utils/navigation.utils';
import { getBlogPath } from '@/utils/paths';

export const NAVIGATION_DATA: (NavItem | MenuItemGroup)[] = [
  {
    id: 'news',
    name: 'News',
    path: '/news',
    icon: <NewspaperIcon className="h-5 w-5" />,
    navItemType: NavItemType.GamePage,
  },
  {
    id: 'matches',
    name: 'Matches',
    path: '/matches',
    icon: <FireIcon className="h-5 w-5" />,
    navItemType: NavItemType.GamePage,
  },
  {
    id: 'betting-hub',
    name: 'Betting HUB',
    path: '/hub',
    icon: <RocketLaunchIcon className="h-5 w-5" />,
    navItemType: NavItemType.RegularPage,
    subLinks: [
      {
        id: 'bookmakers',
        name: 'Bookmakers',
        path: '/hub',
        navItemType: NavItemType.RegularPage,
        icon: (
          <BookmakersIcon
            className="h-4 w-4"
            desc="Bookmakers menu icon"
            title="Bookmakers"
          />
        ),
      },
      {
        id: 'bonuses',
        name: 'Bonuses',
        path: '/hub/bonuses',
        navItemType: NavItemType.RegularPage,
        icon: (
          <BonusesIcon
            className="h-4 w-4"
            desc="Bonuses menu icon"
            title="Bonuses"
          />
        ),
      },
    ],
  },
  {
    id: 'tips',
    name: 'Tips',
    path: '/tips',
    icon: <LightBulbIcon className="h-5 w-5" />,
    navItemType: NavItemType.RegularPage,
  },
  {
    id: 'pickems',
    name: "Pick'ems",
    path: '/pickems',
    navItemType: NavItemType.GamePage,
    icon: <TrophyIcon className="h-5 w-5" />,
    subLinks: [
      {
        id: 'pickems',
        name: "Pick'ems HUB",
        path: '/pickems',
        icon: <CubeIcon className="h-5 w-5" />,
        navItemType: NavItemType.RegularPage,
      },
      {
        id: 'dota2-pickems',
        name: 'Dota 2',
        path: `/${Game.DOTA}/pickems`,
        icon: <GameIcon game={Game.DOTA} />,
        navItemType: NavItemType.RegularPage,
      },
      {
        id: 'cs2-pickems',
        name: 'Counter-Strike 2',
        path: `/${Game.CS2}/pickems`,
        icon: <GameIcon game={Game.CS2} />,
        navItemType: NavItemType.RegularPage,
      },
    ],
  },
  {
    id: 'blog',
    name: 'Blog',
    path: getBlogPath(),
    icon: <ChatBubbleLeftEllipsisIcon className="h-5 w-5" />,
    navItemType: NavItemType.BlogPage,
  },
];
